import { getSettings } from './store'

/**
 * Warm shift.
 *
 * Blue light after dark suppresses melatonin, and light sensitivity is a common
 * withdrawal symptom on top of that. Rather than reimplement warm colours per
 * component, one filter is applied at the document root — it covers text,
 * images, canvases and SVG in a single place.
 *
 * It engages between 8pm and 7am rather than all the time, so the app still
 * looks like itself if someone opens it during the day.
 */
export function applyWarmShift(): void {
  const hour = new Date().getHours()
  const dark = hour >= 20 || hour < 7
  const on = getSettings().redShift && dark
  document.documentElement.dataset.warm = on ? '1' : '0'
}

/** Re-check on a timer so the shift arrives on its own if the app is left open. */
export function startWarmShiftClock(): void {
  applyWarmShift()
  setInterval(applyWarmShift, 5 * 60_000)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) applyWarmShift()
  })
}
